<template>
  <v-container fluid>
    <template>
      <v-row>
        <v-col cols="6" class="pb-1 pt-0">
          <v-breadcrumbs :items="itemsBreadcrumbs" class="pl-0 pt-0 pb-1">
            <template v-slot:item="{ item }">
              <v-breadcrumbs-item :href="item.href" :disabled="item.disabled">
                {{ item.text.toUpperCase() }}
              </v-breadcrumbs-item>
            </template>
          </v-breadcrumbs>
        </v-col>
        <v-col cols="6" class="pb-1 pt-0 h-100">
          <office-login></office-login>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="10" class="pt-1">
          <span class="headline font-weight-medium">Compras</span>
        </v-col>
        <v-col cols="2" class="pt-1">
          <v-btn
            dark
            color="#023145"
            width="140"
            class="float-right"
            @click="handleShowFilters"
          >
            Filtros
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-1">
          <v-btn
            dark
            color="success"
            width="140"
            class="float-right"
            @click="handleDownloadReport"
          >
            Descargar XLS
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pt-1">
          <v-card>
            <v-data-table
              :headers="headers"
              :items="purchases"
              :items-per-page="10"
              class="elevation-1 w-table"
              height="57vh"
              fixed-header
              :loading="loading"
              loading-text="Cargando datos ... "
              :options.sync="options"
              :server-items-length="paginated.total"
            >
              <template v-slot:top>
                <span
                  class="ml-3 pt-3 pb-3 subtitle-1 font-weight-bold w-title-table"
                >
                  Todas las compras
                </span>
                <v-divider></v-divider>
              </template>

              <template v-slot:item.register_date="{ item }">
                <span
                  v-if="item.register_date && item.cancelado === true"
                  style="color: red"
                  >{{ item.register_date | moment("DD/MM/YYYY") }}</span
                >
                <span v-if="item.register_date && item.cancelado === false">{{
                  item.register_date | moment("DD/MM/YYYY")
                }}</span>
              </template>

              <template v-slot:item.supplier_id="{ item }">
                <span
                  v-if="item.supplier && item.cancelado === true"
                  style="color: red"
                >
                  {{ item.supplier.name }}
                </span>
                <span v-if="item.supplier && item.cancelado === false">
                  {{ item.supplier.name }}
                </span>
              </template>

              <template v-slot:item.storehouse_id="{ item }">
                <span
                  v-if="item.storehouse && item.cancelado === true"
                  style="color: red"
                >
                  {{ item.storehouse.name }}
                </span>
                <span v-if="item.storehouse && item.cancelado === false">
                  {{ item.storehouse.name }}
                </span>
              </template>

              <template v-slot:item.ruc="{ item }">
                <span
                  v-if="item.supplier && item.cancelado === true"
                  style="color: red"
                >
                  {{ item.supplier.ruc }}
                </span>
                <span v-if="item.supplier && item.cancelado === false">
                  {{ item.supplier.ruc }}
                </span>
              </template>

              <template v-slot:item.tipo="{ item }">
                <span
                  v-if="
                    item.supplier &&
                      item.cancelado === true &&
                      item.credit_purchase === true
                  "
                  style="color: red"
                >
                  CREDITO
                </span>
                <span
                  v-if="
                    item.supplier &&
                      item.cancelado === true &&
                      item.credit_purchase === false
                  "
                  style="color: red"
                >
                  CONTADO
                </span>
                <span
                  v-if="
                    item.supplier &&
                      item.cancelado === false &&
                      item.credit_purchase === true
                  "
                >
                  CREDITO
                </span>
                <span
                  v-if="
                    item.supplier &&
                      item.cancelado === false &&
                      item.credit_purchase === false
                  "
                >
                  CONTADO
                </span>
              </template>

              <template v-slot:item.type_document="{ item }">
                <span
                  v-if="item.type_document && item.cancelado === true"
                  style="color: red"
                >
                  {{ item.type_document }}
                </span>
                <span v-if="item.type_document && item.cancelado === false">
                  {{ item.type_document }}
                </span>
              </template>

              <template v-slot:item.serie="{ item }">
                <span
                  v-if="item.serie && item.cancelado === true"
                  style="color: red"
                >
                  {{ item.serie }}
                </span>
                <span v-if="item.serie && item.cancelado === false">
                  {{ item.serie }}
                </span>
              </template>

              <template v-slot:item.correlative="{ item }">
                <span
                  v-if="item.correlative && item.cancelado === true"
                  style="color: red"
                >
                  {{ item.correlative }}
                </span>
                <span v-if="item.correlative && item.cancelado === false">
                  {{ item.correlative }}
                </span>
              </template>

              <template v-slot:item.discount="{ item }">
                <span
                  v-if="item.discount && item.cancelado === true"
                  style="color: red"
                  >{{ item.discount | currency("S/") }}</span
                >
                <span v-if="item.discount && item.cancelado === false">{{
                  item.discount | currency("S/")
                }}</span>
              </template>

              <template v-slot:item.subtotal="{ item }">
                <span
                  v-if="item.subtotal && item.cancelado === true"
                  style="color: red"
                  >{{ item.subtotal | currency("S/") }}</span
                >
                <span v-if="item.subtotal && item.cancelado === false">{{
                  item.subtotal | currency("S/")
                }}</span>
              </template>

              <template v-slot:item.igv="{ item }">
                <span
                  v-if="item.igv && item.cancelado === true"
                  style="color: red"
                  >{{ item.igv | currency("S/") }}</span
                >
                <span v-if="item.igv && item.cancelado === false">{{
                  item.igv | currency("S/")
                }}</span>
              </template>

              <template v-slot:item.total="{ item }">
                <span
                  class="label-total"
                  v-if="item.total && item.cancelado === true"
                  style="color: red"
                  >{{ item.total | currency("S/") }}</span
                >
                <span
                  class="label-total"
                  v-if="item.total && item.cancelado === false"
                  >{{ item.total | currency("S/") }}</span
                >
              </template>

              <template v-slot:item.detail="{ item }">
                <div class="text-start">
                  <v-icon
                    v-if="item.cancelado === false"
                    size="17"
                    color="blue"
                    @click="handleViewDetail(item)"
                  >
                    fas fa-bars
                  </v-icon>
                  <v-icon
                    v-if="item.cancelado === false"
                    size="17"
                    color="amber"
                    class="ml-2"
                    @click="handleViewUpdate(item)"
                  >
                    fas fa-pen
                  </v-icon>
                  <v-icon
                    v-if="item.cancelado === false"
                    size="17"
                    class="ml-2"
                    color="error"
                    @click="handleDeletePurchase(item)"
                  >
                    far fa-times-circle
                  </v-icon>
                </div>
                <span v-if="item.cancelado === true" class="sale-cancel">
                  ANULADO
                </span>
                <!-- <div
                  v-if="item.cancelado === true"
                  style="width: 10px; height: 10px"
                >
                  <v-icon
                    size="17"
                    class="ml-2"
                    color="error"
                    @click="handleDeletePurchase(item)"
                  >
                  </v-icon>
                </div> -->
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <purchases-filters ref="purchasesFilters"></purchases-filters>
    <download-purchases ref="downloadPurchases"></download-purchases>
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
import router from "@/router/index";
import OfficeLogin from "../../../components/auth/OfficeLogin";
import PurchasesFilters from "../../../components/reports/PurchasesFilters";
import DownloadPurchases from "../../../components/reports/DownloadPurchases";

export default {
  name: "ReportPurchases",
  components: {
    PurchasesFilters,
    OfficeLogin,
    DownloadPurchases,
  },
  data() {
    return {
      itemsBreadcrumbs: [
        {
          text: "Reportes",
          disabled: true,
          href: "",
        },
      ],
      headers: [
        { text: "FECHA", value: "register_date", sortable: false },
        { text: "ALMACÉN", value: "storehouse_id", sortable: false },
        { text: "PROVEEDOR", value: "supplier_id", sortable: false },
        { text: "RUC", value: "ruc", sortable: false },
        { text: "TIPO DE COMPRA", value: "tipo", sortable: false },
        { text: "DOCUMENTO", value: "type_document", sortable: false },
        { text: "SERIE", value: "serie", sortable: false },
        { text: "N° DOC.", value: "correlative", sortable: false },
        { text: "DESCUENTO", value: "discount", sortable: false, align: "end" },
        { text: "SUBTOTAL", value: "subtotal", sortable: false, align: "end" },
        { text: "IGV", value: "igv", sortable: false, align: "end" },
        { text: "TOTAL", value: "total", sortable: false, align: "end" },
        {
          text: "",
          value: "detail",
          sortable: false,
          align: "end",
          width: 100,
        },
      ],
      loading: false,
      options: {},
      dataTable: { page: 1 },
      pageSelected: 1,
      perPage: 10,
    };
  },
  watch: {
    options: {
      handler() {
        this.loading = true;
        this.perPage = this.options.itemsPerPage;
        this.pageSelected = this.options.page;
        this.getPurchases({
          paginated: true,
          page: this.pageSelected,
          itemsPerPage: this.perPage,
          company_id: this.company_id,
        })
          .then((res) => (this.loading = false))
          .catch((err) => (this.loading = false));
      },
      deep: true,
    },
  },
  computed: {
    ...mapState("authentication", ["company_id"]),
    ...mapState("report-purchases", [
      "purchases",
      "file_purchases",
      "filters",
      "paginated",
    ]),
  },
  methods: {
    ...mapActions("report-purchases", [
      "getPurchases",
      "emptyFilePurchases",
      "purchasesExcel",
      "setFilters",
      "selectPurchase",
      "setPurchases",
    ]),
    ...mapActions("suppliers", ["getSuppliers"]),
    ...mapActions("purchases", ["delete", "selectPurchaseToEdit"]),
    handleShowFilters() {
      this.$refs.purchasesFilters.show();
    },
    async handleDownloadReport() {
      this.$refs.downloadPurchases.show();
      /*
            this.emptyFilePurchases();
            let filters_data = Object.assign({}, this.filters);
            filters_data.company_id = this.company_id;
            await this.purchasesExcel(filters_data);
            if (this.file_purchases) {
                let url = process.env.VUE_APP_API_URL_BASE + '/' + this.file_purchases;
                window.open(url);
            }
            */
    },
    handleViewDetail(purchase) {
      this.selectPurchase(purchase);
      router.push("/app/reportes/detalle-compras");
    },
    handleViewUpdate(purchase) {
      this.selectPurchaseToEdit(purchase);
      router.push("/app/logistica/compras");
    },
    handleDeletePurchase(purchase) {
      let message =
        purchase.type_document +
        " " +
        purchase.serie +
        "-" +
        purchase.correlative;
      this.$swal({
        title: "¿Desea confirmar?",
        text:
          "Confirma que desea eliminar la compra cuyo documento es: " + message,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
      }).then(async (result) => {
        if (result.value) {
          if (result.value === true) {
            await this.delete(purchase);
            this.getPurchases({
              company_id: this.company_id,
            });
          }
        }
      });
    },
  },
  created() {
    this.selectPurchase(null);
    this.setFilters(null);
    this.getSuppliers();
    // this.getPurchases({
    //   company_id: this.company_id,
    // });
  },
  destroyed() {
    this.setPurchases([]);
  },
};
</script>

<style scoped>
.label-ruc {
  font-weight: 600;
  color: #3f51b5;
}

.label-total {
  font-weight: 600;
  color: #4caf50;
}
.sale-cancel {
  color: #f44336;
  font-weight: 600;
}
</style>
